import styled from 'styled-components';
import { Container } from '@hud/web-components/Container/Container';

export const OverviewContainer = styled(Container)`
  width: 100%;
`;
